export class EnableImportOnlyOnceGuard {
  constructor(targetModule: any) {
    if (targetModule) {
      throw new Error(
        `${targetModule.constructor.name} has already been imported. Make sure it is only imported in AppModule`
      );
    }
  }
}
